import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'
import { useDepartmentDetailsTable } from './hooks'
import { getRoleLabel } from 'constants/users'
import styles from './DepartmentDetailsTable.module.scss'

const mapSortingPropToQueryParam = {
  name: 'first_name',
  role: 'role',
  email: 'email',
  date_joined: 'date_joined',
}

export const DepartmentDetailsTable = ({ search, id }) => {
  const { state, handlers } = useDepartmentDetailsTable({
    mapSortingPropToQueryParam,
    search,
    id,
  })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table className={styles.table}>
        <Table.Head>
          <Table.Row>
            {R.map(({ columnDef, getToggleSortingHandler, getIsSorted }) => {
              const { accessorKey, header } = columnDef

              return (
                <HeaderCell
                  key={header}
                  alignLeft
                  sortType={getIsSorted()}
                  text={header}
                  onClick={getToggleSortingHandler()}
                  hasSorting={accessorKey}
                />
              )
            }, headers)}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{ title: t`No members available` }}
          isLoaded={R.not(isFetching)}
        >
          {R.map(({ id, original }) => {
            const { first_name, last_name, role, email, date_joined } = original

            return (
              <Table.Row key={id}>
                <TextCell
                  justify="flex-start"
                  text={
                    first_name || last_name
                      ? `${first_name} ${last_name}`
                      : ' - '
                  }
                />
                <TextCell justify="flex-start" text={getRoleLabel(role)} />
                <TextCell justify="flex-start" text={email} />
                <DateCell
                  justify="flex-start"
                  align="left"
                  date={date_joined}
                />
              </Table.Row>
            )
          }, model.rows)}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
